<div class="session">
  <mat-card class="overflow-hidden">
    <div fxLayout="row wrap">
      <div fxFlex.gt-xs="50" fxFlex="100" class="bg-image bg-image-signin">
        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="h-100 py-3">
          <div class="text-xs-center pb-1 mat-text-white">
              <img src="assets/images/vias_logo_en.png" width="280"/>
          </div>
        </div>
      </div>
      <div fxFlex.gt-xs="50" fxFlex="100">
        <mat-card-content class="pa-3">
          <h1 class="mb-0">{{'forgotPass'|translate}}</h1>
          <p class="mat-text-muted text-md mt-0 mb-2">{{'errorTexts.e_general_104'|translate}}</p>
          <p class="mat-text-warn" #errorTxt></p>
          <form [formGroup]="form" (ngSubmit)="sendMail()">
            <div fxLayout="column" fxLayoutAlign="space-around">
              <div class="pb-1">
                <mat-form-field style="width: 100%">
                  <input matInput placeholder="{{'email'|translate}}" [formControl]="form.controls['email']">
                  <mat-icon matSuffix>mail</mat-icon>
                </mat-form-field>
                <small *ngIf="(form.controls['email'].hasError('required') || !form.valid) && form.controls['email'].touched" class="mat-text-warn">
                  {{'errorTexts.e_general_051'|translate}}</small>
              </div>
              <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">{{'sendMail'|translate}}</button>
            </div>
            <div class="pt-1 pb-1 text-xs-right" style="color: blue;">
              <a [routerLink]="['/account/login']">{{'login'|translate}}</a>
            </div>
          </form>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>
